import React from 'react';
import { Box, Paper, Typography, Avatar, Divider, Grid, Chip } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { Person, Email, Badge, Business } from '@mui/icons-material';

const MyProfile: React.FC = () => {
  const { user } = useAuth();
  const emp = user?.employee;
  const initials = emp ? `${emp.firstName?.[0] || ''}${emp.lastName?.[0] || ''}` : (user?.email?.[0] || '?').toUpperCase();

  return (
    <Box maxWidth={600} mx="auto">
      <Typography variant="h5" fontWeight="bold" mb={3}>My Profile</Typography>
      <Paper sx={{ p: 4, borderRadius: 3 }}>
        <Box display="flex" alignItems="center" gap={3} mb={3}>
          <Avatar sx={{ width: 80, height: 80, bgcolor: '#C08A2E', fontSize: 28, fontWeight: 700 }}>{initials}</Avatar>
          <Box>
            <Typography variant="h5" fontWeight="bold">
              {emp ? `${emp.firstName} ${emp.lastName}` : user?.email?.split('@')[0]}
            </Typography>
            <Chip label={user?.role?.replace('_', ' ')} size="small" sx={{ bgcolor: '#F3E6CD', color: '#C08A2E', fontWeight: 600, textTransform: 'capitalize', mt: 0.5 }} />
          </Box>
        </Box>
        <Divider sx={{ mb: 3 }} />
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box display="flex" alignItems="center" gap={1.5} mb={2}>
              <Email sx={{ color: '#C08A2E' }} />
              <Box>
                <Typography variant="caption" color="text.secondary">Email</Typography>
                <Typography variant="body2" fontWeight={500}>{user?.email}</Typography>
              </Box>
            </Box>
          </Grid>
          {emp && (<>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Box display="flex" alignItems="center" gap={1.5} mb={2}>
                <Badge sx={{ color: '#C08A2E' }} />
                <Box>
                  <Typography variant="caption" color="text.secondary">Employee ID</Typography>
                  <Typography variant="body2" fontWeight={500}>{emp.id || '—'}</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Box display="flex" alignItems="center" gap={1.5} mb={2}>
                <Business sx={{ color: '#C08A2E' }} />
                <Box>
                  <Typography variant="caption" color="text.secondary">Department</Typography>
                  <Typography variant="body2" fontWeight={500}>{emp.department?.name || '—'}</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Box display="flex" alignItems="center" gap={1.5} mb={2}>
                <Person sx={{ color: '#C08A2E' }} />
                <Box>
                  <Typography variant="caption" color="text.secondary">Position</Typography>
                  <Typography variant="body2" fontWeight={500}>{emp.position?.title || '—'}</Typography>
                </Box>
              </Box>
            </Grid>
          </>)}
        </Grid>
      </Paper>
    </Box>
  );
};
export default MyProfile;
